import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import * as firebase from 'firebase/app';

interface Overtime {
    active: number;
    activityId: string;
    activityName: string;
    assignationDate: any;
    authorizeId: string;
    authorizeName: string;
    createdAt: any;
    employeeId: string;
    employeeName: string;
    hours: any;
    shipId: string;
    shipName: string;
    updatedAt: any;
    userId: string;
    userName: string;
    workDate: any;
}

interface OvertimeId extends Overtime {
    id: string;
}

@Injectable()
export class OvertimeService {

    overtimeCollection: AngularFirestoreCollection<Overtime>;
    overtimes: any;

    overtimeDocument: AngularFirestoreDocument<OvertimeId>;
    overtime: Observable<OvertimeId>;

    collection: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.OVERTIME_COLLECTION;
    }

    postOvertime(overtimeObject: any) {
        this.overtimeCollection = this.afs.collection(this.collection);

        return this.overtimeCollection.add(overtimeObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getOvertimes() {
        this.overtimeCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1).
            orderBy('assignationDate', 'desc'));

        this.overtimes = this.overtimeCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Overtime;

                const assignationDate = data.assignationDate;
                const authorizeId = data.authorizeId;
                const authorizeName = data.authorizeName;
                const employeeId = data.employeeId;
                const employeeName = data.employeeName;
                const hours = data.hours;
                const userId = data.userId;
                const userName = data.userName;
                const workDate = data.workDate;

                return { id$, assignationDate, authorizeId, authorizeName, employeeId,employeeName, hours, userId, userName, workDate };
            });
        }).map(object => object);

        return this.overtimes;
    }

    getOvertime(id$: string) {
        this.overtimeDocument = this.afs.doc(this.collection + '/' + id$);

        this.overtime = this.overtimeDocument.valueChanges();

        return this.overtime.map(object => object);
    }

    putOvertime(overtimeObject: any, id$: string) {
        this.overtimeCollection = this.afs.collection(this.collection);

        return this.overtimeCollection.doc(id$).update(overtimeObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    delOvertime(id$: string) {
        this.overtimeDocument = this.afs.doc(this.collection + '/' + id$);

        return this.overtimeDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delOvertime(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.overtimeCollection = this.afs.collection(this.collection);

        return this.overtimeCollection.doc(id$).update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    getOvertimesByRangeDate(iWorkDate: any, eWorkDate: any) {
        this.overtimeCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1)
                                  .where('workDate', '>=', iWorkDate).where('workDate', '<=', eWorkDate));

        this.overtimes = this.overtimeCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as Overtime;

                const employeeId = data.employeeId;
                const hours = data.hours;
                const workDate = data.workDate;

                return { id$, employeeId, hours, workDate };
            });
        }).map(object => object);

        return this.overtimes;
    }

}
